<template>
	<core-layout-headline-with-tabs :tabs="tabs">
		{{ $t("policy") }}
	</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"
import { can } from "@/permissions/"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const output = [
				// This is a link to new policy detail in modules
				{
					name: this.$t("overview"),
					to: `/${this.$store.state.tenantId}/policies/detail/policy/${
						this.$route.params.id
					}`
				},
				{
					name: this.$t("endorsements"),
					to: {
						name: "Endorsements",
						params: { id: this.$route.params.id }
					}
				},
				{
					name: this.$t("commission_split"),
					to: {
						name: "PolicyCommissions",
						params: { id: this.$route.params.id }
					}
				},
				{
					name: this.$t("transactions"),
					to: {
						name: "PolicyTransactions",
						params: { id: this.$route.params.id }
					}
				}
			]

			// Add claims if client has permissions
			if (can("readClaims"))
				output.push({
					name: this.$t("claims"),
					to: {
						name: "PolicyClaims",
						params: { id: this.$route.params.id }
					}
				})

			// Logs
			output.push({
				name: this.$t("logs"),
				to: {
					name: "PolicyLogs",
					params: { id: this.$route.params.id }
				}
			})

			return output
		}
	}
}
</script>
